import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, FolderOpenOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";

import {
  Layout,
  Tooltip,
  Input,
  Table,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin,
} from "antd";
import { BOM } from "../../../../../../../services/definedMethod";
import cnt from "../../../../../../../services/definedConstant";

import MainLayout from "../../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../../components/layouts/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../../../customer/customer.config";
import appStatic from "../../../../../../../config/appStatic";

const { Text } = Typography;

const ViewLoanJournalEntries = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { monthList } = appStatic;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [journalEntriesDetail, setJournalEntriesDetail] = useState([]);
  const [journalEntriesList, setJournalEntriesList] = useState([]);

  useEffect(() => {
    getDetail();
  }, []);

  const columns = [
    {
      title: "Entry Id",
      dataIndex: "id",
    },

    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Account",
      dataIndex: "account",
    },
    {
      title: "Credit",
      dataIndex: "credit",
    },
    {
      title: "Debit",
      dataIndex: "debit",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <DetailJournalEntryModal
            state={state}
            userData={userData}
            recordObj={record}
          />
        </>
      ),
    },
  ];

  function getDetail() {
    const params = {
      transactionDetails: true,
      transactionId: `L${state.transactionId}`,
    };
    const url = `${apiConfig.Journalentries}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res?.pageItems;
        setJournalEntriesDetail(objList);

        let tempJournalEntryList = [];

        objList?.forEach((element) => {
          tempJournalEntryList.push({
            key: element?.id,
            id: element?.id,
            type: element?.glAccountType ? element?.glAccountType?.value : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName}(${element?.glAccountCode})`
              : "-",
            debit:
              element?.entryType?.value?.toLowerCase() === "debit"
                ? element?.amount
                : "-",
            credit:
              element?.entryType?.value?.toLowerCase() === "credit"
                ? element?.amount
                : "-",
          });
        });

        setJournalEntriesList(tempJournalEntryList);
      }
    });
  }

  function onCancel() {
    navigate("/detail-child-glim", { state: state });
  }

  const items = [
    {
      label: labelConfig.office,
      children: journalEntriesDetail[0]
        ? journalEntriesDetail[0]?.officeName
        : "-",
    },
    {
      label: labelConfig.createdBy,
      children: journalEntriesDetail[0]
        ? journalEntriesDetail[0]?.createdByUserName
        : "-",
    },

    {
      label: labelConfig.transactionDate,
      children: journalEntriesDetail[0]
        ? `${journalEntriesDetail[0]?.transactionDate[2]} ${
            monthList[journalEntriesDetail[0]?.transactionDate[1] - 1]
          } ${journalEntriesDetail[0]?.transactionDate[0]}`
        : "-",
    },
    {
      label: labelConfig.createdOn,
      children: journalEntriesDetail[0]
        ? `${journalEntriesDetail[0]?.createdDate[2]} ${
            monthList[journalEntriesDetail[0]?.createdDate[1] - 1]
          } ${journalEntriesDetail[0]?.createdDate[0]}`
        : "-",
    },
  ];

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.journalEntries}
        pageItems={staticConfig.viewJournalEntriesBreadcrumbItems}
      />

      <Card
        headStyle={{ borderBottomWidth: 0 }}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title={
          <Row
            style={{
              alignContent: "center",
              width: "8%",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={onCancel}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>
        }
      >
        <Spin spinning={isLoading} size="large">
          <Form
            form={form}
            layout="vertical"
            // onFinish={onSubmit}
          >
            <Row>
              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Row>

            <Row>
              <Divider orientation="left"></Divider>

              <Col span={24} style={{ padding: "0px 8px" }}>
                <Table
                  columns={columns}
                  dataSource={journalEntriesList}
                ></Table>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
};

export default ViewLoanJournalEntries;

const DetailJournalEntryModal = (props) => {
  const { userData, recordObj, state } = props;

  const { session } = userData;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${apiConfig.detailJournalEntry}=${params.transactionId}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // setJournalEntryDetail(objDetail)

        setInputField([
          {
            name: labelConfig.office,
            value: recordObj?.branch,
            type: "general",
          },
          {
            name: labelConfig.entryId,
            value: recordObj?.entryId,
            type: "general",
          },
          {
            name: labelConfig.transactionId,
            value: recordObj?.transactionId,
            type: "general",
          },

          {
            name: labelConfig.transactionDate,
            value: BOM.FormatArrayDate(recordObj?.transactionDate),
            type: "general",
          },
          {
            name: labelConfig.type,
            value: recordObj.type,
            type: "general",
          },

          {
            name: labelConfig.account,
            value: recordObj?.account,
            type: "general",
          },
          {
            name: labelConfig.debit,
            value: recordObj?.debit,
            type: "general",
          },
          {
            name: labelConfig.paymentTypeId,
            value: recordObj?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },

          {
            name: labelConfig.accountNo,
            value: recordObj?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },

          {
            name: labelConfig.chequeNo,
            value: recordObj?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },

          {
            name: labelConfig.routingCode,
            value: recordObj?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },

          {
            name: labelConfig.receiptNo,
            value: objDetail?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },
          {
            name: labelConfig.bankNo,
            value: objDetail?.paymentDetailData?.paymentType?.name,
            type: "payment",
          },
          {
            name: labelConfig.createdBy,
            value: recordObj?.createdBy,
            type: "payment",
          },
          {
            name: labelConfig.createdOn,
            value: BOM.FormatArrayDate(recordObj?.createdDate),
            type: "payment",
          },
        ]);

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById(state);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Journal Entry Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
            <Row>
              <Divider orientation="left">
                {labelConfig.paymentInformation}
              </Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "payment" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
